function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 1.488c0-.27.219-.488.488-.488h3.256a.488.488 0 110 .977H2.667l3.236 3.236a.488.488 0 01-.69.69L1.977 2.667v2.077a.488.488 0 11-.977 0V1.488zm9.767 0c0-.27.22-.488.489-.488h3.256c.27 0 .488.219.488.488v3.256a.488.488 0 01-.977 0V2.667l-3.236 3.236a.488.488 0 01-.69-.69l3.236-3.236h-2.077a.488.488 0 01-.489-.489zm-4.864 8.609c.191.19.191.5 0 .69l-3.236 3.236h2.077a.488.488 0 110 .977H1.488A.488.488 0 011 14.512v-3.256a.488.488 0 01.977 0v2.077l3.236-3.236c.19-.191.5-.191.69 0zm4.194 0c.19-.191.5-.191.69 0l3.236 3.236v-2.077a.488.488 0 11.977 0v3.256c0 .27-.219.488-.488.488h-3.256a.488.488 0 010-.977h2.077l-3.236-3.236a.488.488 0 010-.69z",
  fill: "#2D2D2D"
});
function SvgExpandir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Expandir.svg";
export { SvgExpandir as ReactComponent };